"use client"

import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useCallback } from "react"
import { SlidersHorizontal } from "lucide-react"

const SORT_OPTIONS = [
  { value: "created_at", label: "Latest Arrivals" },
  { value: "price_asc", label: "Price: Low → High" },
  { value: "price_desc", label: "Price: High → Low" },
]

const BEST_SELLER_OPTION = { value: "bestseller", label: "Best Seller" }

export default function SubCategorySortSelect({
  sortBy,
  includeBestSeller,
}: {
  sortBy: string
  /** Prepends a "Best Seller" option — only the World Cup page's grid matches this against the reference site */
  includeBestSeller?: boolean
}) {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const handleChange = useCallback(
    (value: string) => {
      const params = new URLSearchParams(searchParams)
      params.set("sortBy", value)
      params.delete("page")
      router.push(`${pathname}?${params.toString()}`)
    },
    [router, pathname, searchParams]
  )

  return (
    <div className="relative flex items-center gap-1.5 flex-shrink-0">
      <SlidersHorizontal className="w-4 h-4 text-gray-500 flex-shrink-0" aria-hidden="true" />
      <select
        value={sortBy}
        onChange={(e) => handleChange(e.target.value)}
        className="appearance-none bg-transparent text-sm text-gray-700 font-medium pr-5 cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-brand-primary rounded"
        aria-label="Sort products"
      >
        {(includeBestSeller ? [BEST_SELLER_OPTION, ...SORT_OPTIONS] : SORT_OPTIONS).map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <svg
        className="absolute right-0 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500 pointer-events-none"
        viewBox="0 0 16 16"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}
